$('document').ready(() => {
    $.fn.fileUploader = function (filesToUpload, sectionIdentifier) {
        let fileIdCounter = 0;
        this.closest(".attachment-file").change(function (evt) {
            let output = [];
            for (let i = 0; i < evt.target.files.length; i++) {
                fileIdCounter++;
                let file = evt.target.files[i];
                let fileId = sectionIdentifier + fileIdCounter;
                filesToUpload.push({
                    id: fileId,
                    file: file
                });
                let removeLink = `<a class="attachment-file__remove" href="#" data-fileid=${fileId}>Remove</a>`;
                output.push(`<li class="attachment-file__item"><span>${escape(file.name)}</span>${removeLink}</li>`);
            };
            $(this).children(".attachment-file__list")
                .append(output.join(""));
            evt.target.value = null;
        });

        $(this).on("click", ".attachment-file__remove", function (e) {
            e.preventDefault();
            let fileId = $(this).parent().children("a").data("fileid");
            for (let i = 0; i < filesToUpload.length; ++i) {
                if (filesToUpload[i].id === fileId)
                    filesToUpload.splice(i, 1);
            }
            $(this).parent().remove();
        });

        this.clear = function () {
            for (let i = 0; i < filesToUpload.length; ++i) {
                if (filesToUpload[i].id.indexOf(sectionIdentifier) >= 0)
                    filesToUpload.splice(i, 1);
            }

            $(this).children(".attachment-file__list").empty();
        }

        return this;
    };
    let filesToUpload = [];
    let orderFilesAttach = $("#attachment-file").fileUploader(filesToUpload, "attachment-file");
})
